const Index = () => import('./index')

export default {
  path: '/Main',
  name: 'Main',
  component: Index
}



// WEBPACK FOOTER //
// ./src/page/main/route.js